import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyerPopups } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const cycle = (delay: number) => {
      timeout = window.setTimeout(() => {
        setVisible(true);
        timeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % buyerPopups.length);
          cycle(9000);
        }, 5200);
      }, delay);
    };
    cycle(6000);
    return () => window.clearTimeout(timeout);
  }, [dismissed, index]);
  const buyer = buyerPopups[index];
  return <AnimatePresence data-id="element-42" data-mp="1cvr5041mvcod">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-40 w-[calc(100%-1.5rem)] max-w-[19rem] sm:left-5 sm:bottom-28" role="status" data-id="element-43" data-mp="1gxvwaw4lzx7u">
          <div className="relative flex items-start gap-3 rounded-2xl border border-navy-100 bg-white p-3 pr-8 shadow-xl" data-id="element-44" data-mp="1axqw5u7fkd0v">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-mint/20 text-mint" data-id="element-45" data-mp="n7ddguaqjqiy">
              <CheckCircle2Icon className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="iaekwg6pzrmv" />
            </span>
            <div className="min-w-0" data-id="element-47" data-mp="x382q89gsjup">
              <p className="text-sm font-bold leading-tight text-navy-800" data-id="element-48" data-mp="s5ojetxwtgvw">
                {buyer.name} from {buyer.country}
              </p>
              <p className="mt-0.5 text-xs leading-snug text-navy-500" data-id="element-49" data-mp="28imwl36dmvll">
                just purchased ALIGNER CONTROL SYSTEM™
              </p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-navy-300" data-id="element-50" data-mp="2aotgq36xhdde">
                A few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-navy-300 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-600" data-id="element-51" data-mp="2fpqxcbcahzcs">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="1wx6cnh6qv0k2" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}